const getDefaultUserPreferences = () => {
  return {
    userProfile: {
      doNotPromptForSignature: false,
    },
    display: {
      isDarkMode: false,
      fontSize: 2, // 1 = sm; 2 = md; 3 = lg
    },
    notifications: {},
    projects: {
      projectsShownInMainMenu: [],
    },
    dailyReports: {
      shiftHours: {
        inputStyle: "dropdown",
        contractorStartShift: "0630",
        contractorEndShift: "1500",
        engineerStartShift: "0700",
        engineerEndShift: "1530",
      },
      crews: {
        showMyCrewsOnly: false,
        inputStyle: "dropdown",
      },
      copy: {
        includeWorkDesc: false,
        includeHours: false,
        includeGenComments: false,
      },
    },
  };
};

export default getDefaultUserPreferences;
